import React, { useState, useEffect } from 'react';
import { EMAIL_HAS_ALREADY_BEEN_TAKEN, YesNoOptionsWithBooleanValues, animatedlogo, REQUIRED_FEATURE_FLAGS } from 'helpers/sf_constants';
import { Card, Col, Container, Label, Row, Alert } from "reactstrap";
import MetaTags from "react-meta-tags"
import { AppConfiguration } from "config";
import { Link, useHistory } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import ToastAlert, { ToastAlertIconType } from 'components/Common/ToastAlert/ToastAlert';
import { registerUser } from 'store/actions';
import UserStyle from 'pages/Admin/Users/Users.module.css';
import { getPrimaryButtonClass, getPrimaryTextClass } from 'helpers/sf_utils';
import { WHITE_LABELED_PRODUCT_NAMES } from 'config';
import useClearableTimeout from 'hooks/useClearableTimeout';
import useRegistratonPage from 'hooks/useRegistratonPage';
import useFeatureFlags from 'hooks/useFeatureFlags';
import { useMemo } from 'react';

const RegistrationWithCampaignCreation = () => {

    const urlParams = new URLSearchParams(location.search);
    const history = useHistory();
    const dispatch = useDispatch();
    const [customTimeoutSet] = useClearableTimeout();
    const [is_admin_adding_client, admin_url_param, registration_pending_user_url_param] = useRegistratonPage();

    const [checkUserInfo, setCheckUserInfo] = useState(false);

    const [isFeatureFlagActive] = useFeatureFlags();
    const registration_page_enhancements = useMemo(() => (isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_REGISTRATION_PAGE_ENHANCEMENTS)), [isFeatureFlagActive])

    const { 
        user_info, 
        campaigns_to_be_created, 
        loading, 
        registrationError,
        registration_pending_user 
    } = useSelector((state) => ({
        user_info: state.Account.set_user_to_be_created,
        campaigns_to_be_created: state.Account.campaigns_to_be_created,
        loading: state.Account.loading,
        registrationError: state.Account.registrationError,
        registration_pending_user: state.Account.registration_pending_user
    }), shallowEqual);

    // redirect handler start
    const onSetUserInfoTimeout = () => {
        setCheckUserInfo(false);
        setTimeout(() => {
            setCheckUserInfo(true);
        }, 1000);
    };

    useEffect(() => {
        //Check if user_info exists, it is a fix for situations when a user directy enters url
        onSetUserInfoTimeout();
    }, []);

    const redirectBackToRegister = () => {
        if (urlParams.get('invoice_user') !== null) {
            history.push("/register?invoice_user=" + urlParams.get('invoice_user') + registration_pending_user_url_param)
        } else if (urlParams.get('inv_sid') !== null) {
            history.push("/register?inv_sid=" + urlParams.get('inv_sid') + admin_url_param + registration_pending_user_url_param)
        } else if (urlParams.get('sid') !== null) {
            history.push("/register?sid=" + urlParams.get('sid') + admin_url_param + registration_pending_user_url_param)
        } else {
            history.push("/register" + registration_pending_user_url_param.replace(/&/, '?'))
        }
    }

    useEffect(() => {
        if (registrationError && registrationError === EMAIL_HAS_ALREADY_BEEN_TAKEN) {
            customTimeoutSet(() => {
                redirectBackToRegister();
            }, 1000);
        }
    }, [registrationError]);

    useEffect(() => {
        if (checkUserInfo === true && (!user_info)) {
            ToastAlert.fire({ icon: ToastAlertIconType.ERROR, title: 'Please enter user info first' });
            history.push('/register')
        }
    }, [checkUserInfo]);

    const onSubmitClick = (value) => {
        if (value) {
            if (urlParams.get('invoice_user') !== null) {
                history.push("/register/create-campaign?invoice_user=" + urlParams.get('invoice_user') + registration_pending_user_url_param)
            } else if (urlParams.get('inv_sid') !== null) {
                history.push("/register/create-campaign?inv_sid=" + urlParams.get('inv_sid') + admin_url_param + registration_pending_user_url_param)
            } else if (urlParams.get('sid') !== null) {
                history.push("/register/create-campaign?sid=" + urlParams.get('sid') + admin_url_param + registration_pending_user_url_param)
            } else {
                history.push("/register/create-campaign" + registration_pending_user_url_param.replace(/&/, '?'))
            }
        }
        else {
            if (urlParams.get('invoice_user') !== null) {
                const signup_info_data = {};
                signup_info_data.invoice_user = 1
                signup_info_data.user = user_info;
                signup_info_data.accept_terms_of_service = user_info?.accept_terms_of_service || false
                signup_info_data.is_admin_adding_client = is_admin_adding_client
                signup_info_data.send_create_password_email = user_info?.send_create_password_email
                signup_info_data.campaigns = campaigns_to_be_created;
                if (registration_page_enhancements) {
                    signup_info_data.registration_pending_user_id = registration_pending_user?.id
                }
                dispatch(registerUser(signup_info_data, history))
            } else if (urlParams.get('inv_sid') !== null) {
                const signup_info_data = {};
                signup_info_data.invoice_user = 1
                signup_info_data.sid = urlParams.get('inv_sid')
                signup_info_data.user = user_info;
                signup_info_data.accept_terms_of_service = user_info?.accept_terms_of_service || false
                signup_info_data.is_admin_adding_client = is_admin_adding_client
                signup_info_data.send_create_password_email = user_info?.send_create_password_email
                signup_info_data.campaigns = campaigns_to_be_created;
                if (registration_page_enhancements) {
                    signup_info_data.registration_pending_user_id = registration_pending_user?.id
                }
                dispatch(registerUser(signup_info_data, history))
            } else if (urlParams.get('sid') !== null) {
                history.push("/register/billing-registration?sid=" + urlParams.get('sid') + admin_url_param + registration_pending_user_url_param)
            }
            else {
                history.push("/register/billing-registration" + registration_pending_user_url_param.replace(/&/, '?'))
            }
        }
    }

    const productName = AppConfiguration.PRODUCT_NAME

    return (
        <React.Fragment>
            <MetaTags>
                <title>Create Campaign | {AppConfiguration.WEBSITE}</title>
            </MetaTags>
            <div className="account-pages mt-5 pt-sm-5">
                <Container>
                    <Row className="justify-content-center mt-5">
                        <Col md={8} lg={6} xl={6}>
                            <Card className="overflow-hidden">
                                <div className="bg-white bg-soft">
                                    <Row>
                                        <Col xs={12}>
                                            <div className="text-center p-4">
                                                <img src={animatedlogo} height={32} />
                                            </div>
                                        </Col>

                                        <Col xl={12}>
                                            <div className="mb-3 p-4">
                                                <h5 className={`mb-2 font-weight-bold ${getPrimaryTextClass()}`}>
                                                    Campaigns
                                                </h5>

                                                {!!campaigns_to_be_created?.length && campaigns_to_be_created.map(item => (
                                                    <div className="mt-3">
                                                        <div className={`w-75 mb-1 ${UserStyle.selected_filter}`} style={{ background: "#DDEBF6" }}>
                                                            <div className="d-flex align-items-center">
                                                                <i className="mdi mdi-check text-success font-size-18" /> <span><b className='mx-1'>Successfully Created: </b>{item?.campaign_name || ""}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}

                                                <h6 className="font-weight-bold text-black mt-4">
                                                    {productName === WHITE_LABELED_PRODUCT_NAMES.GOAL ? campaigns_to_be_created?.length ?
                                                        "Do you want to create another quote funnels campaign?" :
                                                        "Do you want to create a quote funnels campaign right now?" : campaigns_to_be_created?.length ?
                                                        "Do you want to create another call or lead campaign?" :
                                                        "Do you want to create a call or lead campaign right now?"}
                                                </h6>

                                                {registrationError && (<Col className='mt-3'>
                                                    <Alert color="danger" className='sf-text-capitalize'>{registrationError}</Alert>
                                                </Col>)}

                                                <div className="mt-4">
                                                    <div className="d-flex flex-wrap gap-3">
                                                        {
                                                            YesNoOptionsWithBooleanValues.map(single_lead_type => {
                                                                return (
                                                                    <div className="campaign-type text-center" onClick={(event) => {
                                                                        event.preventDefault();
                                                                        onSubmitClick(single_lead_type.value)
                                                                    }}
                                                                        key={single_lead_type.value}>
                                                                        <input
                                                                            type="radio"
                                                                            className="btn-check"
                                                                            name={single_lead_type.label}
                                                                            value={single_lead_type.value}
                                                                            id={`register-campaign-creation-${single_lead_type.label}`}
                                                                            autoComplete="off"
                                                                        />
                                                                        <Label className="btn text-capitalize"
                                                                            htmlFor={`register-campaign-creation-${single_lead_type.label}`}>
                                                                            {single_lead_type.label}
                                                                        </Label>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>

                                                <div className="mt-4 d-grid">
                                                    <button className={`btn ${getPrimaryButtonClass()} btn-block`} onClick={(event) => {
                                                        event.preventDefault();
                                                        onSubmitClick(false)
                                                    }} type="submit">
                                                        {(loading) ? 'Please wait...' : 'Continue'}
                                                    </button>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Card>
                            <div className="mt-5 text-center">
                                <p className="text-white">
                                    Already have an account ?{" "}
                                    <Link to="/login" className="font-weight-medium text-sfblue">
                                        {" "}
                                        Login
                                    </Link>{" "}
                                </p>
                                <p className="text-white">© {new Date().getFullYear()} {AppConfiguration.WEBSITE}</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default RegistrationWithCampaignCreation
